import { useEffect, useState } from "react";

export function useDarkMode() {
  const prefersDarkMode = usePrefersDarkMode();
  const [isEnabled, setIsEnabled] = useSafeLocalStorage("darkMode", undefined);

  const enabled = isEnabled === undefined ? prefersDarkMode : isEnabled;

  useEffect(() => {
    if (window === undefined) return;
    const root = window.document.documentElement;
    root.classList.remove(enabled ? "light" : "dark");
    root.classList.add(enabled ? "dark" : "light");
  }, [enabled]);

  return [enabled, setIsEnabled];
}

export function useDarkModeState() {
  const prefersDarkMode = usePrefersDarkMode();

  const savedValue = window.localStorage.getItem("darkMode");

  const [isDarkMode, setIsDarkMode] = useState(savedValue ? savedValue !== 'false' : prefersDarkMode);

  // console.log('isDarkMode: ', isDarkMode);

  const handler = () => {
    setIsDarkMode(window.localStorage.getItem("darkMode") === 'true');
  };

  useEffect(() => {
    window.addEventListener("theme-change", handler);
    return () => {
      window.removeEventListener("theme-change", handler);
    };
  }, []);

  return isDarkMode;
}

export function usePrefersDarkMode() {
  const [value, setValue] = useState(true);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setValue(mediaQuery.matches);

    mediaQuery.addEventListener("change", () => setValue(mediaQuery.matches));
    return () =>
      mediaQuery.removeEventListener("change", () =>
        setValue(mediaQuery.matches)
      );
  }, []);

  return value;
}

export function useSafeLocalStorage(key, initialValue) {
  const [valueProxy, setValueProxy] = useState(() => {
    try {
      const value = window.localStorage.getItem(key);
      return value ? JSON.parse(value) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = (value) => {
    try {
      window.localStorage.setItem(key, value);
      setValueProxy(value);
    } catch {
      setValueProxy(value);
    }
    window.dispatchEvent(new Event("theme-change"));
  };

  return [valueProxy, setValue];
}
